import React from "react";
import AboutIntro from "./AboutIntro";
import Values from "./Values";
import History from "./History";
import ProcessIntro from "./ProcessIntro";
import Process from "./Process";

export default function AboutUs() {
  return (
    <>
      <AboutIntro />
      <Values />
      <History />
      <ProcessIntro />
      <Process />
    </>
  );
}
